
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LoginScaffold extends Vue {
    // nothing here
}
